export default __webpack_public_path__ + "static/educacao-infantil-hover-feaae7d77534796710df4dc1f03df480.svg";